"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDomains = void 0;
exports.AppDomains = ['floating-escarpment', 'localhost', 'discountobvious'];
